import { render, staticRenderFns } from "./AssessmentValueBase.vue?vue&type=template&id=9bc0fae0&scoped=true"
import script from "./AssessmentValueBase.vue?vue&type=script&lang=js"
export * from "./AssessmentValueBase.vue?vue&type=script&lang=js"
import style0 from "./AssessmentValueBase.vue?vue&type=style&index=0&id=9bc0fae0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bc0fae0",
  null
  
)

export default component.exports